import React from "react";
import { ProjectCardsProps } from "@utils/constants";
import Projectcard from "@shared/cards/ProjectCard";
import { DevProject } from "@interfaces/app.interface";
import DevelopersPagination from "@shared/navbars/DevelopersNavbar/Pagination";

interface AllProjectsProps extends ProjectCardsProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const AllProjects: React.FC<AllProjectsProps> = ({
  projects,
  client,
  currentPage,
  totalPages,
  onPageChange,
}) => {
  return (
    <div>
      <div>
        {projects?.length === 0 ? (
          <h4 className="text-center my-10">No projects yet!</h4>
        ) : (
          <div className="projects-div">
            {projects?.map((p: DevProject, idx: number) => (
              <div key={idx}>
                <Projectcard project={p} client={client} />
              </div>
            ))}
          </div>
        )}
      </div>
      <DevelopersPagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default AllProjects;
